import React from 'react';
import classnames from 'classnames';
import { Offer, useFeatureFlags } from '@funtech-int/yango-shared';

import { renderWithBr } from '@/shared/lib/renderWithBr';
import { PlusPaymentPlace } from '@/shared/constants/payments';

import { useMultiOfferTab } from '../../hooks/useMultiOfferTab';
import { useI18n } from '../../hooks/useOnboardingI18n';
import { getMultiOfferTabByPlace } from '../../lib/offers';

import { MultiOfferPlan } from './MultiOfferPlan';
import styles from './MultiOffersPlans.module.css';

interface MultiOffersPlansProps {
    titleClassName?: string;
    offers: Offer[] | null | undefined;
    offer: Offer | undefined;

    isWideMultiOfferDesktopEnabled: boolean;
    isBadgeEnabled: boolean;
}

export const MultiOffersPlans = ({
    titleClassName,
    offers,
    offer,
    isWideMultiOfferDesktopEnabled,
    isBadgeEnabled,
}: MultiOffersPlansProps) => {
    const { tabId, setMultiOfferTab } = useMultiOfferTab();
    const i18n = useI18n();
    const { flags } = useFeatureFlags();
    const isPlusPaywallEnabled = flags.get('isPlusPaywallEnabled', 'boolean', false);

    if (!offers) {
        return [];
    }

    return (
        <div className={styles.root}>
            {isPlusPaywallEnabled && (
                <img
                    className={styles.plusLogo}
                    src={offer?.offerTexts?.customTexts.plusLogo}
                    alt=""
                />
            )}
            <h1
                className={classnames(
                    styles.title,
                    titleClassName,
                    isWideMultiOfferDesktopEnabled && styles.wideMultiOffer,
                    isPlusPaywallEnabled && styles.plusTitle
                )}
            >
                {renderWithBr(
                    offer?.offerTexts?.customTexts.paywallTitle,
                    i18n('multi_paywall_title', { br: <br /> })
                )}
            </h1>
            <div className={styles.plansWrapper}>
                {offers?.map((offer, index) => {
                    const multiOfferTab = getMultiOfferTabByPlace(offer.place as PlusPaymentPlace);

                    return (
                        <MultiOfferPlan
                            isWideMultiOfferDesktopEnabled={isWideMultiOfferDesktopEnabled}
                            key={offer.target}
                            selected={tabId === multiOfferTab}
                            withBadge={index === 0 && isBadgeEnabled}
                            onClick={() => {
                                setMultiOfferTab(multiOfferTab);
                            }}
                            offer={offer}
                        />
                    );
                })}
            </div>
        </div>
    );
};
